const glob_const = {
   http_codes: {                    // https://fr.wikipedia.org/wiki/Liste_des_codes_HTTP
      OK: 200,                      // Requête traitée avec succès
      OK_NO_CONTENT: 204,           // Requête traitée avec succès mais pas d’information à renvoyer
      BAD_REQUEST: 400,             // La syntaxe de la requête est erronée
      UNAUTHORIZED: 401,            // Une authentification est nécessaire pour accéder à la ressource
      FORBIDDEN: 403,               // Le serveur a compris la requête, mais refuse de l'exécuter
      NOT_FOUND: 404,               // Ressource non trouvée
      CONFLICT: 409,                // La requête ne peut être traitée à la suite d'un conflit avec l'état actuel du serveur
      INTERNAL_SERVER_ERROR: 500,   // Erreur interne du serveur
   },

   min_delay_on_push: 5,            /* Délai minimum (sec) quand on push vers AppWrite et qu'on obtient
                                       un event en retour. Si le délai est inférieur à cette valeur,
                                       on ne refresh pas la BDD locale (Dexie) */

   stock_levels: {
      WARN: 5,
      NOK: 0,
   },

   fam_bo: '05',
   bo_mono: 'MONO',
   bo_paire: 'PAIRE',
   depot_defaut: 'J01',

   /** Dépôts retail (warehouses M3 alimentés en stocks retail).
       Codes :
         - SFR : France
         - SUS : USA
         - SMO : Moyen-Orient
         - SCN : Chine
         - SJP : Japon
       Règles d'accès :
         - admin / N1 → on interroge tous ces dépôts
         - N2          → uniquement `customer.depot_retail` + `retail_depot_central` (SFR)
         - Clients     → uniquement `customer.depot_retail` (CLI_STOCKEUR M3) */
   retail_depots: ['SFR', 'SUS', 'SMO', 'SCN', 'SJP'],
   /** Dépôt retail central, toujours visible pour les N2 en complément du dépôt client. */
   retail_depot_central: 'SFR',
   /** Mapping code dépôt → nom long (pour affichage UI). */
   retail_depot_names: {
      SFR: 'France',
      SUS: 'USA',
      SMO: 'Moyen-Orient',
      SCN: 'Chine',
      SJP: 'Japon',
   },
   /** Mapping code dépôt → champ PCB sur le model retail (utilisé pour vérifier si une qté est multiple du PCB). */
   retail_depot_pcb_field: {
      SFR: 'pcb_fr',
      SUS: 'pcb_us',
      SCN: 'pcb_cn',
      SJP: 'pcb_jp',
      SMO: 'pcb_fr',   // SMO n'a pas de PCB dédié, on retombe sur celui de la France
   },

   /** Famille retail pour laquelle on affiche le "par combien" (PCB) */
   retail_fam_pcb: '82',   // OAV

   /** Famille retail "Packaging" (code M3 = '85'). Utilisée comme repère pour
       les commandes hors grille (KOT/KTM) où PACKAGING reste offert par défaut.
       Les ECR/ECF appliquent désormais leurs remises via la grille — cf.
       DocRetail/GRILLE_ECR_ECF.txt → libs/retail_rules.getRetailFamilleDiscount. */
   retail_fam_packaging: '85',

   /**
   auto_familles: {                 / * Cochage auto d'autres familles quand on coche une famille
                                       Exemple : 'XX': ['YY', 'ZZ', 'AA']
                                       Aussi utilisé pour le groupage de familles à l'affichage :
                                       la clé sert à grouper le reste
                                    * /
      '01': ['18', '19', '20']      // Bagues (01) -> Alliances (18). Solitaire <1ct et Solitaire >=1ct
   },
   **/

   check_sw_update_delay: 15 * 60 * 1000,  // Toutes les 15min on check si nv version dispo. 1er check fait dès l'arrivée au login

   prefix_prospect: "P_",
   prefix_ktm: "KTM_",
   regex_ome_doc_id: /^[0-9a-f]{4}-[0-9]{1,7}$/, // Ex: 4c18-192 et le 192 peut aller jusqu'à 7 chiffres 10 millions de commandes :-)
   retail_enabled: true,           // true = affichage et prise en charge du mode retail
   /** TEMPORAIRE (jusqu'à nouvel ordre) : masque le catalogue Retail pour les
       COMMERCIAUX / internes (rôle non retail : ni client, ni admin, ni manager N1/N2).
       Les clients, managers et admins conservent l'accès. Appliqué au point unique
       Hooks/useRetailCatalogScope. Pour rétablir : repasser ce flag à false. */
   retail_catalog_hidden_for_commercials: true,
   otp_enabled: false,             // false = double-authent OTP (TOTP) désactivée pour le moment (code conservé) ; le reset mdp passe par un PIN envoyé par mail

   /** Groupes clients M3 (CLI_RETGC) : code -> { type Retail, scope Group/Filiale, label, has_quota }
       has_quota = true → ce groupe est soumis aux quotas (KOT) Retail.
       Modifier ici pour ajouter/retirer/réaffecter un groupe sans toucher au code métier. */
   customer_groups: {
      '010': { type: 'RET', scope: 'group',   label: 'Retail Interne Group',   has_quota: true  },
      '020': { type: 'RET', scope: 'filiale', label: 'Retail Interne Filiale', has_quota: false },
      '030': { type: 'ERE', scope: 'group',   label: 'Retail Externe Group',   has_quota: false },
      '040': { type: 'ERE', scope: 'filiale', label: 'Retail Externe Filiale', has_quota: false },
      // Wholesale (050/060) : non géré pour le moment (cf. DocRetail/GRILLE_ECR_ECF.txt).
      '070': { type: 'INT', scope: 'group',   label: 'Interco Group',     has_quota: true  },
      '080': { type: 'INT', scope: 'filiale', label: 'Interco Filiale',   has_quota: true  },
   },

   /** Zones géographiques M3 : code -> { label }
       Codes utilisés par la matrice de droits ECR/ECF (cf. retail_rules.ts).
       Toute autre valeur → pas d'ECR/ECF possible. */
   geo_zones: {
      '010': { label: 'Europe' },           // Europe (dont Afrique et DOM TOM)
      '020': { label: 'Japon' },
      '030': { label: 'Chine' },
      '040': { label: 'Amériques' },        // sauf USA
      '050': { label: 'USA' },
      '060': { label: 'Moyen Orient' },
      '070': { label: 'APAC' },             // Asie sauf Chine et Japon
   },

   /** Exclusivités boutique M3 : code -> { label }
       Modifier ici pour ajouter/retirer/réaffecter une exclusivité sans toucher au code métier. */
   exclu_boutiques: {
      '010': { label: 'Boutiques Filiales' },
      '020': { label: 'Boutiques Group' },
      '030': { label: 'Filiales' },
   },
}

export default glob_const